// src/components/Footer.jsx
import React from 'react';

const Footer = () => (
  <footer className="footer" data-scroll-section>
    <p>&copy; 2025 NRGPIX.CH — All rights reserved.</p>
  </footer>
);

export default Footer;